import {
  DateOcrExtractionProvider,
  DateOcrExtractionResult,
} from "./DateOcrExtractionProvider"

/**
 * Fallback OCR provider used as the default context value when no provider
 * has been wired by a container. Every extraction fails immediately so the
 * component stays in a well-defined state without a real backend; a container
 * is expected to inject a working provider via DateOcrProviderContext.
 */
export class DefaultDateOcrExtractionProvider
  implements DateOcrExtractionProvider {
  public async extractDate(): Promise<DateOcrExtractionResult> {
    return {
      success: false,
      failureReason: "ERROR",
      errorMessage: "No OCR provider configured",
    }
  }
}
